module.exports = __webpack_public_path__ + "static/carousel-japan-2-3482c0a6d7bbea039b43a845a46dbeaa.jpg";